import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Options from './options/Options';
import OnlineAsistance from './menu/OnlineAsistance';
import ReparationHome from './menu/ReparationHome';
import ReviewTuning from './menu/ReviewTuning';
import { SERVICE_TYPES } from '../../helper/types';

import '../../assets/styles/Services.css';

function ProfessionalSolution({type}) {
  const [selectedService, setSelectedService] = useState(type);

  const selectService = (serviceType) => {
    setSelectedService(serviceType);
  };

  const resetSelection = () => {
    setSelectedService(SERVICE_TYPES.NONE);
  };

  const isServiceSelected = selectedService !== SERVICE_TYPES.NONE;

  return (
    <div className="servicios-container" style={{ marginTop: '10px', width: '100%' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} justifyContent="space-between">
          {!isServiceSelected && (
            <>
              <Grid item xs={6} container justifyContent="flex-start">
                <Typography sx={{ marginLeft: '100px', fontSize: '30px' }}>Servicios</Typography>
              </Grid>
              <Grid item xs={6} container alignItems="center" justifyContent="flex-end">
                <Button onClick={() => selectService(SERVICE_TYPES.ONLINE_ASSISTANCE)} sx={{ mr: '100px', textTransform: 'none', color: 'black' }}>
                  Asistencia Online y Telefónica →
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
        {!isServiceSelected && (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
            <Grid container spacing={2} justifyContent="center" style={{ paddingTop: '50px', paddingBottom: '120px' }}>
              <Grid item xs={4} container justifyContent="space-around">
                <OnlineAsistance handleButtonClick={() => selectService(SERVICE_TYPES.ONLINE_ASSISTANCE)} />
              </Grid>
              <Grid item xs={4} container justifyContent="space-around">
                <ReviewTuning handleButtonClick={() => selectService(SERVICE_TYPES.REVIEW_TUNING)} />
              </Grid>
              <Grid item xs={4} container justifyContent="space-around">
                <ReparationHome handleButtonClick={() => selectService(SERVICE_TYPES.HOME_REPAIR)} />
              </Grid>
            </Grid>
          </Box>
        )}
        {isServiceSelected && (
          <Grid container spacing={2} justifyContent="center" style={{marginTop:  '6px'}}>
            <Options backToService={resetSelection} type={selectedService}/>
          </Grid>
        )}
      </Box>
    </div>
  );
}

export default ProfessionalSolution;
